export default function TextAreaInput({ label, placeholder, value, handleChange }) {
    return (
        <div className="flex items-center mb-10">
            {label ?
                <label className="text-[14px] w-28 inline-block text-right mr-4 text-gray-500">{label}</label>
                : null}
            <textarea rows="5"
                placeholder={placeholder}
                className="placeholder:text-sm rounded-lg border-2 border-gray-400 flex-1 p-2 placeholder-gray-300 outline-none focus:border-main-color transition duration-300"
                value={value ? value : ""}
                onChange={handleChange}
                onFocus={(e) => e.target.placeholder = ""}
                onBlur={(e) => e.target.placeholder = `${placeholder ? placeholder : ""}`}
            />
        </div>
    )
}